// LoginForm.js
import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { useNavigate } from "react-router-dom";

export default function LoginForm() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const ok = await login(username, password);
    console.log("login() returned:", ok);

    if (ok) {
      console.log("Navigating to /dashboard");
      navigate("/dashboard");
    } else {
      console.log("Login failed in form");
      setError("Invalid username or password.");
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: "2rem",
      }}
    >
      <div className="card login-card">
        <img
          src="/assets/anti-ajmal-logo.png"
          alt="Anti Ajmal"
          style={{ width: 150, maxWidth: "70%", margin: "0 auto 1rem", display: "block" }}
        />
        <h2 style={{ textAlign: "center", marginTop: 0 }}>Anti Ajmal Login</h2>

        <form onSubmit={handleSubmit} style={{ display: "grid", gap: 12 }}>
          <div>
            <label className="label">Username</label>
            <input
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{ width: "100%" }}
            />
          </div>

          <div>
            <label className="label">Password</label>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: "100%" }}
            />
          </div>

          {error && <div style={{ color: "#d00073", textAlign: "center" }}>{error}</div>}

          <button className="btn" type="submit" style={{ width: "100%" }}>
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
